/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as ReportRouteImport } from './routes/report'
import { Route as AuthenticatedGuaranteesRouteImport } from './routes/_authenticated/guarantees'
import { Route as AuthenticatedRenewalsRouteImport } from './routes/_authenticated/renewals'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedRenewalsRenewalIdRouteImport } from './routes/_authenticated/renewals_.$renewalId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportRoute = ReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedGuaranteesRoute = AuthenticatedGuaranteesRouteImport.update({
  id: '/guarantees',
  path: '/guarantees',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRenewalsRoute = AuthenticatedRenewalsRouteImport.update({
  id: '/renewals',
  path: '/renewals',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRenewalsRenewalIdRoute =
  AuthenticatedRenewalsRenewalIdRouteImport.update({
    id: '/renewals_/$renewalId',
    path: '/renewals/$renewalId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/report': typeof ReportRoute
  '/guarantees': typeof AuthenticatedGuaranteesRoute
  '/renewals': typeof AuthenticatedRenewalsRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/renewals/$renewalId': typeof AuthenticatedRenewalsRenewalIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/report': typeof ReportRoute
  '/guarantees': typeof AuthenticatedGuaranteesRoute
  '/renewals': typeof AuthenticatedRenewalsRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/renewals/$renewalId': typeof AuthenticatedRenewalsRenewalIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/report': typeof ReportRoute
  '/_authenticated/guarantees': typeof AuthenticatedGuaranteesRoute
  '/_authenticated/renewals': typeof AuthenticatedRenewalsRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRoute
  '/_authenticated/renewals_/$renewalId': typeof AuthenticatedRenewalsRenewalIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/report'
    | '/guarantees'
    | '/renewals'
    | '/reports'
    | '/renewals/$renewalId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/report'
    | '/guarantees'
    | '/renewals'
    | '/reports'
    | '/renewals/$renewalId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/report'
    | '/_authenticated/guarantees'
    | '/_authenticated/renewals'
    | '/_authenticated/reports'
    | '/_authenticated/renewals_/$renewalId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ReportRoute: typeof ReportRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/report': {
      id: '/report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof ReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/guarantees': {
      id: '/_authenticated/guarantees'
      path: '/guarantees'
      fullPath: '/guarantees'
      preLoaderRoute: typeof AuthenticatedGuaranteesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/renewals': {
      id: '/_authenticated/renewals'
      path: '/renewals'
      fullPath: '/renewals'
      preLoaderRoute: typeof AuthenticatedRenewalsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/renewals_/$renewalId': {
      id: '/_authenticated/renewals_/$renewalId'
      path: '/renewals/$renewalId'
      fullPath: '/renewals/$renewalId'
      preLoaderRoute: typeof AuthenticatedRenewalsRenewalIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedGuaranteesRoute: typeof AuthenticatedGuaranteesRoute
  AuthenticatedRenewalsRoute: typeof AuthenticatedRenewalsRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRoute
  AuthenticatedRenewalsRenewalIdRoute: typeof AuthenticatedRenewalsRenewalIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedGuaranteesRoute: AuthenticatedGuaranteesRoute,
  AuthenticatedRenewalsRoute: AuthenticatedRenewalsRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRoute,
  AuthenticatedRenewalsRenewalIdRoute: AuthenticatedRenewalsRenewalIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ReportRoute: ReportRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
